import type { WorkshopModule } from '@/lib/api/types';
import { padIndex } from '@/lib/format';
import styles from './ModuleNav.module.scss';

interface ModuleNavProps {
  modules: readonly WorkshopModule[];
  activeModule: number;
  onSelect: (moduleIndex: number) => void;
}

export function ModuleNav({ modules, activeModule, onSelect }: ModuleNavProps) {
  return (
    <nav className={styles.nav} aria-label="Workshop contents">
      <p className={styles.label}>Contents</p>
      <ul>
        {modules.map((module, index) => {
          const state = index === activeModule ? styles.active : index < activeModule ? styles.done : '';
          return (
            <li key={`${module.title}-${index}`}>
              <button
                type="button"
                className={`${styles.item} ${state}`}
                aria-current={index === activeModule ? 'true' : undefined}
                onClick={() => onSelect(index)}
              >
                <span className={styles.num}>{padIndex(index)}</span>
                <span className={styles.text}>
                  {module.title}
                  {module.time && <em className={styles.time}>{module.time}</em>}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
